export default __webpack_public_path__ + "static/media/header_plate.b703daf3.png";